import { render } from "./SocialSecurityTemplate.vue?vue&type=template&id=2f6dac94"
import script from "./SocialSecurityTemplate.vue?vue&type=script&lang=js"
export * from "./SocialSecurityTemplate.vue?vue&type=script&lang=js"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__